module.exports = __webpack_public_path__ + "static/media/office_banner.dae31ca2.jpg";